import React from "react";
import autoBind from "react-autobind";
import _ from "lodash";

import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
class PlayerBarcodeScanner extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;

		this.state = {
			value: this.getValueFromItem(this.props.item, "")
		};

		autoBind(this);
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.state.value); }
	}

	getValueFromItem(item, defaultValue) {
		const value = (item.hasOwnProperty("barcode") && item.barcode.hasOwnProperty("data") && item.barcode.data !== "") ? item.barcode.data : defaultValue;
		return value;
	}

	onChange(event) {
		this.setState({ value: event.target.value });
	}

	onBlur(event) {
		if (this.props.onChange) { this.props.onChange(event.target.value); }
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.item.barcode !== this.props.item.barcode) {
			this.setState({ value: this.getValueFromItem(nextProps.item) });
		}
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	renderReadOnly() {
		const item = this.props.item;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflowX: "auto" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
					{this.props.getImage()}
					{this.props.getVideo()}
					{this.props.getPdf()}
					<div>
						{
							this.getValueFromItem(item, "(No Data)")
						}
					</div>
				</div>
			</div>
		);
	}

	renderEditable() {
		const { item, listIndex, sectionIndex, itemIndex, disabled } = this.props;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;

		const barCodeScannerTheme = _.assign({ marginBottom: "15px" }, _.get(theme, "item.barcodeScanner.textInput", {}));

		const component = <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ width: "100%", overflowX: "auto" }}>
				<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
				<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
				{this.props.getImage()}
				{this.props.getVideo()}
				{this.props.getPdf()}
				<div>
					<textarea
						rows={5}
						style={barCodeScannerTheme}
						className="form-control"
						type="text"
						value={this.state.value}
						onChange={this.onChange}
						onBlur={this.onBlur}
						disabled={disabled}
						ref={(ref) => { this.textInput = ref; }} />
				</div>
				{!disabled && <DoneButton onSubmit={this.onSubmit} />}
			</div>
		</div>;
		return component;
	}
}

export default withPlayerItemHoc(PlayerBarcodeScanner);